import React, { useState } from 'react'
import '../static/style/navbar.css'
import logo from '../static/images/logo.png'
import Asidebar from './Asidebar';
import MenuIcon from '@mui/icons-material/Menu';


import cv from '../files/cv__bekkar__merwan.pdf'
function Navbar() {
    const [Openaside , setOpenaside] = useState(false)
  return (
    <nav>
        <div className='logo'>
            <img src={logo} alt='logo' />
        </div>
        <div className='liens'>
            <a href='#'>About</a>
            <a href='#'>Work</a>
            <a href='#'>Skills</a>
            <a href='#'>Contact</a>
            <a href={cv} target="_blank" type="application/pdf"><button>Resume</button></a>
        </div>
        <button className='menu' onClick={()=>{setOpenaside(true) }}>
            <MenuIcon/>
        </button>
        {Openaside && <Asidebar setOpenaside={setOpenaside} />}
    </nav>
  )
}

export default Navbar